import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { flowMonthCalendar } from './monthcalendar.theme';

export const flowYearCalendar: Components<Theme>['MuiYearCalendar'] = {
  ...(flowMonthCalendar as Components<Theme>['MuiYearCalendar']),
};
